import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import { color } from "styled-system";
import { styled } from "../theme";
const I = styled.i `
  color: inherit;
  font-size: ${({ fontSize }) => fontSize}px;
  ${color}
`;
export const Icon = ({ name, className, size = 20, ...props }) => (_jsx(I, { className: cx("icon", `icon-${name}`, className), fontSize: size, ...props }));
